import { Directive, OnDestroy, OnInit, inject, input } from "@angular/core";
import { HelpContextService } from "./help-context.service";

/**
 * Declares the help context of a component or a dialog while it is shown: `<div appHelpContext="protocols.viewer">`.
 * The key must be in HELP_CONTEXTS.
 */
@Directive({
	selector: "[appHelpContext]",
})
export class HelpContextDirective implements OnInit, OnDestroy {
	private contexts = inject(HelpContextService);
	readonly appHelpContext = input.required<string>();
	private key: string | null = null;

	ngOnInit(): void {
		this.key = this.appHelpContext();
		this.contexts.push(this.key);
	}

	ngOnDestroy(): void {
		if (this.key) {
			this.contexts.pop(this.key);
		}
	}
}
